export const BARCODE_LOCAL_STORAGE_KEY = 'barcodes';